import { SendOutlined } from '@ant-design/icons';
import { Button, Modal, notification } from 'antd';
import { FC, useState } from 'react';

import { errorObjectToString } from 'src/utils/common';
import { callSendDailyPricePush } from 'src/utils/firebase/firebase-callable';

interface DailyPricePushModalProps {
  title: string;
  month: number;
}

const DailyPricePushModal: FC<DailyPricePushModalProps> = ({ title, month }) => {
  const [open, setOpen] = useState(false);

  const openModal = () => {
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
  };

  const sendDailyPriceList = () => {
    notification.info({
      message: '발송 요청이 전송되었습니다.',
      description: '결과는 슬랙에서 확인하세요.',
    });

    // 응답을 기다리지 않고 백그라운드에서 처리
    callSendDailyPricePush({ title, month })
      .then((response) => {
        const { result, reason, stats } = response.data;
        if (result === 'success' && stats) {
          notification.success({
            message: '발송 완료',
            description: `발송 대상: ${stats.targetUsers}명, 전체 ${stats.total}건 중 성공 ${stats.success}건, 실패 ${stats.fail}건`,
          });
        } else {
          notification.error({
            message: '발송 실패',
            description: reason,
          });
        }
      })
      .catch((error) => {
        const errorMessage = errorObjectToString(error);
        notification.error({
          message: '에러 발생',
          description: errorMessage,
        });
      });

    closeModal();
  };

  return (
    <>
      <Button type='primary' size='large' icon={<SendOutlined />} onClick={openModal}>
        일일 가격 알림 일괄전송
      </Button>
      <Modal
        open={open}
        centered
        title='일일 가격 알림 발송'
        onCancel={closeModal}
        okText='전송시작'
        onOk={sendDailyPriceList}
      >
        <div style={{ padding: '20px 0' }}>
          <p>
            <strong>제목:</strong> {title}
          </p>
          <p>
            <strong>관심 상품 조회 기간:</strong> {month}개월
          </p>
          <p style={{ marginTop: 16, color: '#666' }}>알림 수신 동의 사용자에게 관심 상품 가격 알림을 발송합니다.</p>
        </div>
      </Modal>
    </>
  );
};

export default DailyPricePushModal;
